<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-title">
      <p>学习数据统计</p>
    </div>
    <div class="panel-content center_content">
      <div class="course_info">
        <div class="panel-title">
          <p v-if="lessonInfo">{{ lessonInfo ? lessonInfo.title : '' }}</p>
          <p v-if="lessonInfo">负责人:{{  lessonInfo.manager &&  lessonInfo.manager ? lessonInfo.manager.name : '' }}</p>
        </div>
        <div class="course_btn">
          <!-- <router-link
            tag="div"
            :to="'/www/lesson_detail?id=' + lessonInfo.id"
            class="add-btn"
          >预览</router-link> -->
        </div>
      </div>
      <div id="searchSection">
        <div class="search-line clearfix">
          <select
            class="s-select separate"
            v-model="queryInfo.onlineClass_id"
          >
            <option value="">选择班级</option>
            <option
              :value="item.id"
              v-for="item in classData"
              :key="item.id"
            >{{item.title}}</option>
          </select>
          <input
            type="text"
            placeholder="学生姓名"
            class="s-input separate"
            v-model="queryInfo.name"
          >
          <input
            type="button"
            value="搜索"
            @click="search"
            class="s-btn"
          >
        </div>
        <div class="search-line clearfix">
        </div>
      </div>
      <div id="list">
        <table>
          <tbody>
            <tr class="l_header">
              <th class="itemStatus">账号</th>
              <th class="itemStatus">姓名</th>
              <th class="itemStatus">性别</th>
              <th class="itemStatus">学院</th>
              <th class="itemStatus">专业</th>
              <th class="itemStatus">选课时间</th>
              <th class="itemStatus">班级名称</th>
              <th class="itemStatus">测试成绩</th>
              <th
                class="action"
                width="130"
              >操作
              </th>
            </tr>
            <tr
              class="item"
              v-for="(item, index) in tableData"
              :key="index"
            >
              <td>{{ item.userProfile.username }}</td>
              <td>{{ item.userProfile.name }}</td>
              <td>{{ formatGender(item.userProfile.gender) }}</td>
              <td>{{ formatAcademy(item.userProfile.academy) }}</td>
              <td>{{ formatMajor(item.userProfile.major)}}</td>
              <td>{{ item.created.toString().substr(0, 10) }}</td>
              <td>{{ item.onlineClass ? item.onlineClass.title : '' }}</td>
              <td>{{item.grade?item.grade:'--'}}</td>
              <td>
                <router-link
                  tag="a"
                  :to="`/online/statistics/study/progress?id=${lessonInfo.id}&studentId=${item.id}`"
                >查看学习进度</router-link>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          class="noitems"
          v-if="tableData.length == 0"
        >没有数据</div>
      </div>
      <!-- 分页 -->
      <pagination
        :cur='pageInfo.page'
        :all='pageInfo.all'
        :totalData="pageInfo.totalData"
        :callback="pageCallback"
      ></pagination>
    </div>

  </div>
</template>

<script>
import Pagination from '../../../components/Pager'

export default {
  name: 'StudyStatistics',
  components: {
    Pagination
  },
  props: [
    'lessonInfo'
  ],
  data() {
    return {
      academyData: [],
      classData: [],
      classShowUserWindow: {
        visibility: 'hidden'
      },
      classShowClassWindow: {
        visibility: 'hidden'
      },
      queryInfo: {
        page: 1,
        size: 10,
        onlineClass_id: '',
        name: '',
        lessonOnline_id: this.$route.query.id
      },
      tableData: [],
      tableDataCount: 0,
      formSearchUser: {
        page: 1,
        size: 10,
        name: '',
        role: '12'
      },
      userData: [],
      userDataCount: 0,
      formClass: {
        onlineStudent_id: null,
        onlineClass_id: null
      },
      subjectData: []
    }
  },
  methods: {
    showUserWindow() {
      this.classShowUserWindow = {
        visibility: 'visible'
      }
    },
    hideUserWindow() {
      this.classShowUserWindow = {
        visibility: 'hidden'
      }
    },
    async search() {
      await this.$http.get('/online_student/', {
        params: this.queryInfo
      }).then((data) => {
        this.tableData = data.results
        this.tableDataCount = data.count
      }).catch((error) => {
        console.log(error)
      })
    },
    async searchSubject() {
      await this.$http.get('/major/', {
        params: {
          page: 1,
          size: 10000
        }
      }).then((data) => {
        this.subjectData = data.results
      }).catch((error) => {
        console.log(error)
      })
    },
    pageCallback(data) {
      this.queryInfo.page = data
      this.search()
    },
    pageUserCallback(data) {
      this.formSearchUser.page = data
      this.getUserList()
    },
    async getUserList() {
      await this.$http.get('/userprofile/', {
        params: this.formSearchUser
      }).then((data) => {
        this.userData = data.results
        this.userDataCount = data.count
      }).catch((error) => {
        console.log(error)
      })
    },
    formatGender(value) {
      if (value === '1') {
        return '男'
      } else if (value === '0') {
        return '女'
      } else if (value === '男' || value === '女') {
        return value
      } else {
        return '--'
      }
    },
    formatAcademy(value) {
      const academyId = this.academyData.map(item => item.id)
      return this.academyData[academyId.indexOf(value)] ? this.academyData[academyId.indexOf(value)].title : '--'
    },
    formatMajor(value) {
      const subjectId = this.subjectData.map(item => item.id)
      return this.subjectData[subjectId.indexOf(value)] ? this.subjectData[subjectId.indexOf(value)].title : '--'
    },
    async getAcademy() {
      const params = {
        page: 1,
        size: 1000
      }
      await this.$http.get('/academy/', { params }).then((data) => {
        this.academyData = data.results
      }).catch((error) => {
        console.log(error)
      })
    },

    async getClass() {
      await this.$http.get('/online_class/', {
        params: {
          page: 1,
          size: 10000,
          lessonOnline_id: this.$route.query.id
        }
      }).then((data) => {
        this.classData = data.results
      })
    }

  },
  mounted() {
    this.search()
    this.getAcademy()
    this.searchSubject()
    this.getUserList()
    this.getClass()
  },
  computed: {
    pageInfo() {
      return {
        page: this.queryInfo.page,
        all: Math.ceil(this.tableDataCount / this.queryInfo.size),
        totalData: this.tableDataCount
      }
    },
    teacherPageInfo() {
      return {
        page: this.formSearchUser.page,
        all: Math.ceil(this.userDataCount / this.formSearchUser.size),
        totalData: this.userDataCount
      }
    }
  }
}
</script>

<style scoped src="@/assets/css/project-detail.css"></style>
<style lang="less" scoped>
.panel-content {
  padding: 20px 40px;
}

.c-content {
  margin: 0;
  transform: translate(-50%, -50%);
}

.itemStatus {
  img {
    width: 120px;
  }
}

#c-panel {
  z-index: 2;
}

.c-content {
  min-height: 650px;
}

.active {
  color: #266dc7 !important;
  text-decoration: underline;
}

.course_info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  .panel-title {
    p {
      display: inline-block;
      margin-right: 20px;

      &:last-child {
        color: #999;
        font-size: 16px;
      }
    }
  }

  .course_btn {
    div {
      margin-left: 20px;
      padding: 7px 20px;
      background: #73D6CA;
      color: #fff;
      border-radius: 3px;

      &:first-child {
        background: #25c7a8;
      }

      &:nth-child(2) {
        border: 1px solid #73D6CA;
        color: #73D6CA;
        background: #fff;
      }
    }
  }
}

.crumb_nav {
  color: #999;
  margin-top: 20px;
}

.add-btn {
  width: unset;
  height: unset;
  line-height: normal;
}

.item img {
  max-height: 40px;
  margin-top: 4px;
}

#list td,
.f_list td {
  padding: 5px;
}
</style>
